// extracted by mini-css-extract-plugin
export var anchor = "_2t-0";
export var discard = "_2t-4";
export var muiTooltipTooltip = "_2t-6";
export var notificationBar = "_2t-3";
export var saveButtonHoverSlotWrapper = "_2t-5";
export var show = "_2t-2";
export var spacer = "_2t-1";